<script lang="ts" setup>
import { ref, Ref, computed } from "vue";
import { useApiStore, type Project } from "@/stores/api";

const apiStore = useApiStore();

const projects: Ref<Project[]> = ref([]);

apiStore.getProjects({ categories: [4], categories_exclude: [3], per_page: 4, exclude: [] }).then((p: Project[]) => (projects.value = p));

const getColor = (color: "bg-beige-100" | "bg-beige-200" | "bg-beige-300" | "bg-brown-100" | "bg-brown-200" | "bg-gold") => {
    let text = "text-white";

    if (["bg-beige-100", "bg-beige-200", "bg-beige-300"].includes(color)) {
        text = "text-brown-200";
    }
    return `${color} ${text}`;
};
</script>

<template>
    <div class="w-full text-center mb-[44px] text-38 font-bold tracking-[0.24px]">Onze projecten</div>
    <div class="grid lg:grid-cols-2 gap-x-[132px] gap-y-[30px]">
        <a v-for="(project, index) in projects" :href="project.link" class="relative overflow-hidden cta-project-readmore" data-aos="fade-up" :data-project-readmore="project.title.rendered">
            <div v-if="project.acf.special_note && project.acf.special_note.text" class="absolute top-0 left-0 text-white font-bold uppercase h-[56px] w-full flex items-center justify-center bg-brown-200" :class="getColor(project.acf.special_note.color)">{{ project.acf.special_note.text }}</div>
            <img :data-src="project.acf.primary_image" class="lazyload mb-[30px] h-[312px] object-cover w-full" :class="{ 'pt-[56px]': project.acf.special_note && project.acf.special_note.text }" />
	    <div v-if="project.acf && project.acf.label_text" class="sold-circle" v-html="project.acf.label_text"></div>          
	    <div v-else-if="project.acf && project.acf.sold_percentage" class="sold-circle">
                <span>reeds</span>
                <span class="text-[130%] leading-[0.9]">{{ project.acf.sold_percentage }}%</span>
                <span class="leading-[1]">verkocht</span>
            </div>
            <div class="text-24 font-medium mb-[4px]">{{ project.title.rendered }}</div>
            <div class="mb-[19px] text-14 leading-[24px] tracking-[0.09px] font-light">{{ project.acf.location }} - {{ project.acf.city }}</div>
            <div class="text-15 font-light mb-[24px]" v-html="project.acf.description"></div>
            <button class="inline-flex items-center justify-center h-[48px] bg-brown-100 text-white font-bold px-[38px] hover:bg-beige-200 hover:text-brown-200 transition-colors">Bekijk project</button>
        </a>
    </div>
</template>
